import CourseTable from "#training/components/course/CourseTable"
import { Box } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"

const Course = () => {
	ChangeTitle("Cursos")
	return (
		<Box>
			<CourseTable />
		</Box>
	)
}

export default Course
